// import * as ACTION from '../Actions/actionTypes';
import * as ACTION from "../actions/GetChainId/SetChainIdActionType"
import { UpdateObject } from "../../utils/utils";

const initialState = {
  chainId: "",
};

const ChainIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.SET_CHAIN_ID:
      return getChainId(state, action);

    default:
      return state;
  }
};

const getChainId = (state, action) => {
  return UpdateObject(state, {
    chainId: action.payload,
  });
};

export default ChainIdReducer;